import { userAPI } from '../UserAPI';

export interface MarketplaceData {
    offers: any[];
    featured: any[];
}

/*
 * The marketplace list is slow to fetch (hundreds of KB, uncompressed) and it is public data
 * that changes rarely. So the last result is kept for the session: coming back to the
 * marketplace shows it at once and refreshes it in the background.
 */
let cache: MarketplaceData | null = null;
let inflight: Promise<MarketplaceData> | null = null;

export const getCachedMarketplaceData = (): MarketplaceData | null => cache;

/**
 * Offers and featured offers are fetched side by side (they used to run one after the other).
 * Concurrent callers share one request. A failing "featured" request only costs the ordering,
 * not the list.
 */
export function fetchMarketplaceData(): Promise<MarketplaceData> {
    if (!inflight) {
        inflight = Promise.all([
            userAPI.getPublishedMarketplaceOffers(),
            userAPI.getFeaturedMarketplaceOffers().catch((error: unknown) => {
                console.error('Error loading featured marketplace offers:', error);
                return [] as any[];
            }),
        ])
            .then(([offers, featured]) => {
                cache = { offers, featured };
                return cache;
            })
            .finally(() => {
                inflight = null;
            });
    }
    return inflight;
}
